var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.12 68.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ef9a9d;\n      }\n\n      .cls-3 {\n        fill: #ff006e;\n      }\n\n      .cls-4 {\n        fill: #e85d88;\n      }\n\n      .cls-5 {\n        fill: #ff93b8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.65,48.12l6.38,6.3c.14,.14,.29,.27,.45,.4,.13-.21,.25-.43,.36-.65,.61-1.25,.98-2.63,.98-4.1V18.04c0-5.27-4.35-9.56-9.69-9.56h-3.05c-1,0-1.94,.19-2.85,.47-2.6,.8-4.73,2.62-5.88,5.02-.6,1.24-.96,2.61-.96,4.07v19.56c2.53,.64,5.47,1.87,7.86,4.22l6.38,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.94,47.91c-.41-.37-.94-.71-1.53-1v3.16c0,5.27,4.35,9.56,9.69,9.56h3.05c.23,0,.46-.01,.68-.03l-5.3-5.23-6.58-6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.42,12.21c-.41,.89-.73,1.82-.96,2.79,.23-.97,.56-1.9,.97-2.79h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.25,8.95c.91-.28,1.85-.47,2.85-.47h3.05c5.34,0,9.69,4.29,9.69,9.56V50.06c0,1.48-.37,2.86-.98,4.1-.11,.22-.24,.44-.36,.65,1.09,.89,2.48,1.49,3.76,1.88,.15-.27,.3-.55,.44-.83,.9-1.84,1.44-3.87,1.44-6.04V18.27c0-7.74-6.16-14.24-14-14.24h-2.8c-3.07,0-5.9,.99-8.23,2.63-2.01,1.41-3.62,3.33-4.66,5.56l3.93,1.75c1.15-2.4,3.28-4.22,5.88-5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.42,12.21h.02c1.04-2.23,2.65-4.14,4.66-5.55,2.33-1.64,5.16-2.63,8.23-2.63h2.8c7.84,0,14,6.5,14,14.24v31.57c0,2.17-.54,4.2-1.44,6.04-.14,.28-.28,.56-.44,.83,1.33,.4,2.53,.57,3.16,.57h1.46c.99-2.21,1.55-4.64,1.55-7.21V18.04C45.42,8.09,37.22,0,27.14,0h-3.05c-4.74,0-9.06,1.81-12.31,4.74-1.76,1.59-3.2,3.51-4.23,5.66l3.9,1.73s-.02,.05-.03,.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.83 36.9 2.73 36.9 0 40.93 5.83 40.93 5.83 36.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.39,57.27h-5.98c-.63,0-1.84-.18-3.16-.57-1.28-.39-2.67-.99-3.76-1.88-.16-.13-.31-.26-.45-.4l-6.38-6.3-6.38-6.3c-2.39-2.36-5.33-3.59-7.86-4.22v4.73c2.04,.76,4.19,1.93,6.02,3.73l6.38,6.3,5.69,5.61,.7,.69c.82,.81,1.89,1.38,2.98,1.78,1.77,.65,3.57,.85,4.39,.86h10.56l-2.73-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.84,65.25c1.16,.28,2.22,.41,3.1,.48-.88-.06-1.94-.2-3.09-.48,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 40.93,
    width: 5.83,
    height: 4.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.42,12.21s.02-.05,.03-.08l-3.9-1.73s-.03,.05-.04,.07l3.9,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.78,63.07s-.01,0-.02,0c1.71,1.13,3.48,1.8,5.08,2.18,0,0,0,0,.01,0-1.58-.39-3.34-1.05-5.07-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.76,63.07c-1.33,.5-2.76,.78-4.39,.78l-3.07-.02c-7.96-.37-14.2-6.48-14.2-14.22V18.06c0-1.05,.13-2.07,.36-3.05,.22-.97,.55-1.91,.96-2.79l-3.9-1.74s.03-.05,.04-.07h-.02c-1.08,2.29-1.71,4.85-1.71,7.55V49.98c0,9.95,8.2,18.04,18.28,18.04h3.05c3.56,0,6.88-1.02,9.69-2.76-1.6-.39-3.37-1.05-5.08-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.62,62.98s.01,0,.02,0c-.43-.28-.85-.59-1.27-.94,.41,.35,.83,.66,1.25,.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.62,62.98c-.42-.29-.84-.6-1.25-.94-.56-.46-1.11-.97-1.64-1.55l-.91-.9c-.22,.02-.45,.03-.68,.03h-3.05c-5.34,0-9.69-4.29-9.69-9.56V18.04c0-1.46,.36-2.83,.96-4.07l-3.93-1.75c-.41,.89-.74,1.82-.97,2.79-.22,.95-.34,1.94-.34,2.96v27.56s-.01,0-.02,0v4.09c0,7.74,6.24,13.84,14.2,14.22l3.07,.02c1.63,0,3.05-.28,4.39-.78-.05-.03-.09-.06-.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.13,17.97c0-1.02,.12-2.01,.34-2.96-.23,.98-.36,2-.36,3.05v18.88s.01,0,.02,0V17.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.13,36.94s-.01,0-.02,0v4.27s.01,0,.02,0v-4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.13,41.21s-.01,0-.02,0v4.32s.01,0,.02,0v-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.62,62.98s.09,.06,.14,.09c0,0,.01,0,.02,0-.05-.03-.09-.06-.14-.09,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.52,54.36l5.3,5.23s.02,0,.03,0l-5.33-5.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.95,65.73c1.28,.09,2.18,.02,2.44,.02-.26,0-1.16,.06-2.44-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.73,60.49c.53,.58,1.08,1.09,1.64,1.55-.5-.42-.98-.88-1.45-1.4l-1.07-1.05s-.02,0-.03,0l.91,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.4,61.3h-.83c-.82,0-2.62-.21-4.39-.86-1.09-.4-2.16-.97-2.98-1.78l-.7-.69-5.69-5.61-6.38-6.3c-1.83-1.8-3.98-2.97-6.02-3.73v4.57c.59,.3,1.13,.63,1.53,1l6.58,6.46h0s5.33,5.23,5.33,5.23l1.07,1.05c.47,.52,.96,.98,1.45,1.4,.42,.34,.84,.65,1.27,.94,.05,.03,.09,.06,.14,.09,1.73,1.13,3.49,1.79,5.07,2.18,1.15,.28,2.21,.42,3.09,.48,1.27,.09,2.18,.02,2.44,.02h8.74v-4.45h-9.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.832957f8e08bc72034306bba5a9025fc.svg";
export { ForwardRef as ReactComponent };